/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of unicats (patients) to display or load unicats */


(function () {
  'use strict';
  angular.module('vcfinance.unicat')
    .component('unicatlist', {
      restrict: 'E',
      bindings: {},
      template: `
        <h2 id="toc">Inhaltsverzeichnis</h2>
        <div class="row" ng-repeat="chap in vm.tree.chapters">
          <div class="col-xs-12">
            <h3>{{chap._id}}</h3>
            <div class="threecol">
              <div ng-repeat="cat in chap.categories" class="keeptogether"><a ng-click="vm.goto(cat.categorie)">{{cat.categorie}}</a>
                <ul>
                    <li ng-repeat="grp in cat.groups"><a ng-click="vm.goto(grp.group)">{{grp.group}}</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="panel-heading"><h3>{{cat.categorie}}</h3></div>-->
          <div class="row" ng-repeat="chap in vm.tree.chapters">
            <div class="col-xs-12">
            <h2>
                <span class="pull-left"> Kapitel {{chap._id}}</span>
                <span class="pull-right"><i class="fa fa-list" uib-tooltip="Inhaltverzeichnis" ng-click="vm.goto('toc')"></i></span>
                <div class="clearfix"></div>
            </h2>
            <div class="panel panel-info" ng-repeat="cat in chap.categories">
              <div class="panel-heading">
                <h3 id="{{cat.categorie}}">
                   <span class="pull-left">{{cat.categorie}}</span>
                   <span class="pull-right"><i class="fa fa-list"  ng-click="vm.goto('toc')" uib-tooltip="Inhaltverzeichnis"></i></span>
                   <div class="clearfix"></div>
                </h3>
              </div>
              <div class="panel-body">
                <div ng-repeat="grp in cat.groups">
                  <div class="grptitle">
                    <h3  id="{{grp.group}}">
                        <span class="pull-left">{{grp.group}}</span>
                        <span class="pull-right"><i class="fa fa-list"  ng-click="vm.goto('toc')" uib-tooltip="Inhaltverzeichnis"></i></span>
                        <div class="clearfix"></div>
                    </h3>
                  </div>
                  <div ng-repeat="e in grp.entries ">
                    <h4><a ng-click="vm.toggleedit(e)"> <tt>{{e}} - </tt>{{vm.elu[e].name}}</a></h4>
                    <div ng-show="vm.showedit[e]">
                       <unicateditor entry="vm.elu[e]"></unicateditor>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Unicat', 'UnicatHelper', 'vertxEventBusService', '$location', '$anchorScroll',
        function ($log, $http, Rlog, Unicat, UnicatHelper, vertxEventBusService, $location, $anchorScroll) {
          let vm = this;
          vm.removeEntry = removeEntry;
          vm.goto = gotoanchor;
          vm.toggleedit = toggleedit;
          vm.$onInit = function () {

            Unicat.$find('tree').$then(function (tree) {
              vm.tree = tree;
            }, function (err) {
              $log.error('unicat tree lookup failed');
              Rlog.error('unicat', 'unicateditor', 'unicat tree lookup failed', {});
            });


            Unicat.$search({type: 'entry'}).$then(function (unicat) {
              vm.unicat = unicat;
              $log.debug('***** unicat: ', unicat);
              // generate entry lookup table by sprnum
              vm.elu = {};
              vm.showedit = {};
              for (let i = 0; i < unicat.length; i++) {
                vm.elu[unicat[i].sprnum] = unicat[i];
                vm.showedit[unicat[i].sprnum] = false;
              }

            }, function (err) {
              $log.error('unicat not found');
              Rlog.error('unicat', 'unicateditor', 'unicat not found', {});
            });


          }; // $onInit()


          function gotoanchor(target) {
            $location.hash(target);
            $anchorScroll();
          }

          function toggleedit(entry) {
            vm.showedit[entry] = !vm.showedit[entry];
          }

          function removeEntry(unicat) {
            unicat.active = false;
            unicat.$save();
          }

          const unicatUpdateHandler = function (message) {
            $log.debug('debug: unicat update received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.unicat)){
              vm.unicats.$refresh().$then(function () {
                $log.debug('debug: unicatlist refreshed unicat');
              }, function (error) {
                $log.debug('debug: unicatlist refresh unicat failed: ', error);
              });
            }
          };

          vertxEventBusService.on('unicat.update', {}, unicatUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('unicat.update', {}, unicatUpdateHandler);
          };



        }] // controller
    }); // component

  // klammerfriedhof
}());